import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { MediaQuery, Logo, ScrollIntoView, SupportFooter } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';
import { SplitPane } from '@grandvisionhq/layout';
import { useIntl, useStore, useSelector } from '@grandvisionhq/state';
import '../models/cart/cart-state.js';
import { CheckoutStepErrorType } from '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import { StepNames } from '../models/shared.js';
import '@swc/helpers';
import '@grandvisionhq/carts-v2';
import '../context/CheckoutSettings/context.js';
import '@grandvisionhq/utils';
import { getSelectedShippingMethod } from '../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../mappers/errors-mapping.js';
import '../utils/get-customer-details-payload.js';
import 'history';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '../selectors.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-service-store.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/locations';
import '../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import '../state.js';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import 'throttle-debounce';
import '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import '@grandvisionhq/my-account';
import { NavigationContainer } from '../modules/Navigation/NavigationContainer.js';
import '@grandvisionhq/bloomreach';

const CheckoutLayout = ({ hasNavigation , logo , status , currentStep , pageRouteRoot , leftContentSection , cartContentSection  })=>{
    const isOverviewStep = currentStep === StepNames.Overview;
    const isShippingStep = currentStep === StepNames.Shipping;
    const { getLabel  } = useIntl();
    const headerRef = React.useRef(null);
    const store = useStore();
    const isLoggedIn = Selectors.isLoggedIn(store.getState());
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    React.useEffect(()=>{
        headerRef.current && headerRef.current.scrollIntoView();
    }, []);
    /**
   *  check status of payment through
   *  url query params
   */ const alerts = [
        {
            condition: status === CheckoutStepErrorType.Failed,
            titleKey: 'checkout.errors.general.title',
            messageKey: 'checkout.errors.general.message'
        },
        {
            condition: status === CheckoutStepErrorType.ProductPriceUpdated,
            titleKey: 'checkout.errors.general.payment.productPriceUpdated.title',
            messageKey: 'checkout.errors.general.payment.productPriceUpdated.message'
        },
        {
            condition: status === CheckoutStepErrorType.ShippingStepFailed,
            titleKey: 'checkout.errors.general.shipping.title',
            messageKey: 'checkout.errors.general.shipping.message'
        },
        {
            condition: !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched) && isShippingStep,
            titleKey: 'checkout.warning.invalid.delivery.title',
            messageKey: 'checkout.warning.invalid.delivery.message'
        }, 
    ];
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-section"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-section__header",
        ref: headerRef
    }, logo && /*#__PURE__*/ React.createElement(Logo, {
        className: "checkout-section__logo",
        url: pageRouteRoot,
        image: logo,
        title: logo.altText
    }), hasNavigation && /*#__PURE__*/ React.createElement(NavigationContainer, {
        currentStep: currentStep,
        isLoggedIn: isLoggedIn
    })), /*#__PURE__*/ React.createElement(SplitPane, {
        main: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section--main"
        }, isMobile && !isOverviewStep && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__body"
        }, alerts.filter(({ condition  })=>condition
        ).map((alert, index)=>/*#__PURE__*/ React.createElement(ScrollIntoView, {
                key: alert.messageKey
            }, /*#__PURE__*/ React.createElement(Alert, {
                key: index,
                className: "alert-m-default checkout-section__alert",
                variant: "warning",
                title: getLabel(alert.titleKey)
            }, getLabel(alert.messageKey)))
        ), leftContentSection)),
        aside: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section--aside"
        }, !isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cartContentSection ? cartContentSection : null), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__support-footer"
        }, /*#__PURE__*/ React.createElement(SupportFooter, {
            message: getLabel('support.title'),
            phoneNumber: getLabel('support.phoneNumber', {
                hideLabelKey: true
            }) || undefined,
            email: getLabel('support.emailAddress', {
                hideLabelKey: true
            }) || undefined
        })))
    }));
};

export { CheckoutLayout };
//# sourceMappingURL=CheckoutLayout.js.map
